import ApiService from './api';

/**
 * Workout Service
 * Handles all workout-related API requests
 */
const WorkoutService = {
  /**
   * Get all workouts for the current user
   * @param {string} token - Auth token
   * @param {Object} queryParams - Optional query parameters
   * @returns {Promise} - Response data
   */
  getAllWorkouts: async (token, queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    const endpoint = `/api/workouts${queryString ? `?${queryString}` : ''}`;
    
    const response = await ApiService.get(endpoint, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Get a single workout by ID
   * @param {string} workoutId - Workout ID
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getWorkoutById: async (workoutId, token) => {
    const response = await ApiService.get(`/api/workouts/${workoutId}`, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Create a new workout
   * @param {Object} workoutData - Workout data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  createWorkout: async (workoutData, token) => {
    const response = await ApiService.post('/api/workouts', workoutData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Update a workout
   * @param {string} workoutId - Workout ID
   * @param {Object} workoutData - Updated workout data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  updateWorkout: async (workoutId, workoutData, token) => {
    const response = await ApiService.put(`/api/workouts/${workoutId}`, workoutData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Delete a workout
   * @param {string} workoutId - Workout ID
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  deleteWorkout: async (workoutId, token) => {
    const response = await ApiService.delete(`/api/workouts/${workoutId}`, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Get all workout templates
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  getWorkoutTemplates: async (token) => {
    const response = await ApiService.get('/api/workouts/templates', {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  },

  /**
   * Create a workout template
   * @param {Object} templateData - Template data
   * @param {string} token - Auth token
   * @returns {Promise} - Response data
   */
  createWorkoutTemplate: async (templateData, token) => {
    const response = await ApiService.post('/api/workouts/templates', templateData, {
      'Authorization': `Bearer ${token}`
    });
    
    return response.json();
  }
};

export default WorkoutService;
